// extracted by mini-css-extract-plugin
module.exports = {"SearchDiv":"ShopPageActionMenu_SearchDiv__1d7Wo","IconStyle":"ShopPageActionMenu_IconStyle__3YMgE","IconStyleClicked":"ShopPageActionMenu_IconStyleClicked__tI8qg"};